import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_PRODUCTS_API_PATHS } from '../constants/products-api-paths.constants';

type ProductPosition = {
  id: string;
  position: number;
};

type UseUpdateProductsPositionsResult = {
  updatePositions: (products: ProductPosition[]) => Promise<boolean>;
  isSubmitting: boolean;
};

export function useUpdateProductsPositions(): UseUpdateProductsPositionsResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updatePositions = async (products: ProductPosition[]): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      await HttpClient.patch(ADMIN_PRODUCTS_API_PATHS.UPDATE_POSITIONS, { products });

      enqueueSnackbar('Les positions ont été mises à jour', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour des positions'),
        { variant: 'error' }
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updatePositions, isSubmitting };
}
